import {
  DocumentSection,
  EntityDocument,
  ManagementQuote,
} from '@api';
import { Markdown } from '@terminal/components/markdown/Markdown';
import { useDocuments } from '@terminal/react-query-hooks/documents/useDocumentsEntity';
import React from 'react';

import styles from './ManagementCitations.module.scss';

export interface CitationsProps {
  citations: (DocumentSection & ManagementQuote)[];
  onClick: (citationId: string, document: EntityDocument) => void;
  activeIdx?: number;
}

export const ManagementCitations = ({
  citations,
  onClick,
  activeIdx,
}: CitationsProps) => {
  const { data } = useDocuments(citations.map(c => c.document));

  return (
    <>
      {citations.map((citation, idx) => {
        const document = data.find(d => d?.id === citation.document);

        if (!document) {
          return null;
        }

        const { kind, period } = document;
        const { speakerName: nameLabel = '', speakerTitle: titleLabel = '' } =
          citation.tags;

        const firstPartLabel =
          nameLabel && titleLabel
            ? `${nameLabel} - ${titleLabel}`
            : `${nameLabel || titleLabel}`;
        const secondPartLabel = `${period.toUpperCase()} ${kind[0].toUpperCase()}${kind.slice(
          1
        )}`;
        const isActive = idx === activeIdx;

        return (
          <div
            key={citation.id}
            className={isActive ? styles.containerActive : styles.container}
            onClick={() => onClick(citation.id, document)}
          >
            {citation.context && (
              <span className={styles.quoteContext}>{citation.context}</span>
            )}
            <div className={styles.markdownWrapper}>
              <Markdown message={`"${citation.text}"`} />
            </div>
            <span
              className={styles.styledLabel}
            >{`${firstPartLabel} | ${secondPartLabel}`}</span>
          </div>
        );
      })}
    </>
  );
};
